import usStates from '../../common/constants/usStates';
import caProvinces from '../../common/constants/caProvinces';
import auStates from '../../common/constants/auStates';
import { canonicalizeString } from '.';

export default function getRegionByName(regionName) {
  const allRegions = [...usStates, ...caProvinces, ...auStates];
  const canonical = canonicalizeString(regionName);
  return allRegions.find(r => canonical === r.canonical);
}
